// React
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

// Reactstrap
import { Col, Button, Modal, ModalHeader, Label } from 'reactstrap';

// Formik & Yup
import { useFormik } from 'formik';
import * as Yup from 'yup';

export const ModalInputNotesAssociates = (props) => {
  const [selectNotesAssociates, setSelectNotesAssociates] = useState({
    value: 'null',
    label: 'Selecione um tipo de nota',
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      typeInput: props.selectNote
        ? { value: props.selectNote.id, label: props.selectNote.value }
        : null,
      noteInput: props.selectNote ? props.selectNote.note : '',
    },
    validationSchema: Yup.object({
      typeInput: Yup.object().nullable().required('Selecione um tipo de nota'),
      noteInput: Yup.string().trim().required('Nota é obrigatório'),
    }),

    onSubmit: (values) => {
      props.handleSubmit(selectNotesAssociates.value, values.noteInput);
      setSelectNotesAssociates({
        value: null,
        label: 'Selecione um tipo de nota',
      });
      validation.resetForm();
    },
  });

  const createData = () => {
    let data = props.data;
    let newData = data.map((typeNotes) => {
      return {
        value: typeNotes.id,
        label: typeNotes.name,
      };
    });

    return newData;
  };

  const findTypeNotes = (name) => {
    const typeNote = props.data.find(
      (noteTypeItem) => noteTypeItem.name === name
    );

    if (typeNote) {
      setSelectNotesAssociates({
        label: typeNote.name,
        value: typeNote.id,
      });
    }
  };

  useEffect(() => {
    if (props.selectNote) {
      findTypeNotes(props.selectNote.noteType);
    }
  }, [props.selectNote]);

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={props.isOpen}
      toggle={() => {
        props.toogle();
      }}
      modalClassName="fadeInLeft"
      centered
      autoFocus={false}
    >
      <ModalHeader>{props.title}</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <div className="mb-3">
            <label htmlFor="typeInput" className="col-form-label">
              {props.label}
            </label>
            <Col md={12}>
              <div className="mb-3">
                <Select
                  isClearable={true}
                  value={selectNotesAssociates}
                  onChange={(e) => {
                    const event = {
                      target: {
                        name: 'typeInput',
                        value: e,
                      },
                    };
                    setSelectNotesAssociates(e);
                    validation.handleChange(event);
                  }}
                  onBlur={validation.handleBlur}
                  options={createData() || []}
                  id="typeInput"
                  inputId="typeInput"
                />
                {validation.touched.typeInput && validation.errors.typeInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.typeInput}
                  </p>
                ) : null}
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="noteInput" className="form-label">
                  Notas
                </Label>
                <textarea
                  className="form-control"
                  id="noteInput"
                  rows="3"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.noteInput || ''}
                ></textarea>
                {validation.touched.noteInput && validation.errors.noteInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.noteInput}
                  </p>
                ) : null}
              </div>
            </Col>
          </div>
          <div className="modal-footer"><button
              className="btn btn-link"
              color="light"
              onClick={() => {
                setSelectNotesAssociates({
                  value: null,
                  label: 'Selecione um tipo de nota',
                });
                props.toogle();
              }}
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit">
              {' '}
              Salvar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
